import { mapActions, mapGetters } from 'vuex';


export default {
    computed: {
        ...mapGetters(['navigation']),
    },
    methods: {
        ...mapActions(['setNavigation', 'resetNavigation']),
        updateNav(toggle) {
            this.setNavigation({
                level: this.level,
                idx: toggle ? this.idx : -1,
                item: toggle ? this.child : {},
            });
        },
    },
};



// WEBPACK FOOTER //
// ./sib-website/assets/src/js/app/vue/mixins/nav-item/index.js